/**
 * 此reducer用于存放应用临时状态，不会持久化。
 */

import * as types from './actions';

const initialState = {
  loginParamefeeQuery: false, //记录当前是否是退改费用url带参数查询
  flights: [],
  psgs: [],
};

export default function TicketChangesReducer(state = initialState, action) {
  switch (action.type) {
    case types.EDIT_LOGINPARAM_FEEQUERY:
      return Object.assign({}, state, {
        loginParamefeeQuery: !state.loginParamefeeQuery,
      });
    case types.SET_PSGS_FLIGHTS:
      return Object.assign({}, state, {
        flights: action.flights.length ? action.flights : state.flights,
        psgs: action.psgs.length ? action.psgs : state.psgs,
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/routes/modules/current.js